import { render, staticRenderFns } from "./residente.vue?vue&type=template&id=255adc62&scoped=true"
import script from "./residente.vue?vue&type=script&lang=js"
export * from "./residente.vue?vue&type=script&lang=js"
import style0 from "./residente.vue?vue&type=style&index=0&id=255adc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255adc62",
  null
  
)

export default component.exports